import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import type { IInteractionsModelUpdatesHandlers } from './types'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { Interact } from '@wix/interact'
import { name } from './symbols'

export const InteractionsModelUpdatesHandlers = withDependencies(
	[] as const,
	(): IModelUpdatesHandlersImplementor<IInteractionsModelUpdatesHandlers> => {
		return {
			featureName: name,
			handlers: {
				destroyExistingInteractions: async ({ editorMode }) => {
					// When switching into editing mode
					if (editorMode === 'editor') {
						Interact.destroy()
					}
				},
			},
		}
	}
)
